import { Badge, Body1, Caption1, Spinner, tokens } from '@fluentui/react-components';
import { useApi } from '../../api/useApi';
import { useAsync } from '../../api/useAsync';
import { MemberRow, MemberTypeBar } from './GroupMembers';
import type { GroupMemberDto, GroupSummaryDto } from '../../api/types';
import './groups.css';

function SubList({ title, people }: { title: string; people: GroupMemberDto[] }) {
  return (
    <div>
      <div className="grp-sublist-title">
        {title} ({people.length})
      </div>
      {people.length === 0 ? (
        <Caption1 style={{ color: tokens.colorNeutralForeground3 }}>—</Caption1>
      ) : (
        <div className="grp-sublist">
          {people.map((m) => (
            <MemberRow key={m.id} member={m} />
          ))}
        </div>
      )}
    </div>
  );
}

/** Read-only-Detail einer Gruppe: Beschreibung (umbrechend), Typ-Zählung, Owner und Mitglieder. */
export function GroupDetailView({ group }: { group: GroupSummaryDto }) {
  const api = useApi();
  const detail = useAsync(() => api.getGroup(group.id), [api, group.id]);
  const d = detail.data;

  return (
    <div className="grp-panel">
      <div className="grp-panel-head">
        <span className="grp-panel-title">{group.displayName}</span>
        <Badge appearance="tint" color={group.memberCount > 0 ? 'warning' : 'informative'}>
          {group.memberCount} Mitglieder
        </Badge>
      </div>
      <Caption1 style={{ color: tokens.colorNeutralForeground3 }}>{group.groupType}</Caption1>
      {d?.description ? <Body1 className="grp-desc">{d.description}</Body1> : null}
      {detail.loading ? <Spinner size="tiny" label="Lade Details…" /> : null}
      {detail.error ? (
        <Caption1 style={{ color: tokens.colorPaletteRedForeground1 }}>{detail.error.message}</Caption1>
      ) : null}
      {d ? (
        <>
          <MemberTypeBar members={d.members} transitiveCount={d.transitiveMemberCount} />
          <SubList title="Owner" people={d.owners} />
          <SubList title="Mitglieder" people={d.members} />
        </>
      ) : null}
    </div>
  );
}
